module.exports = __webpack_public_path__ + "static/media/pulsidTallaS.d9fd1872.jpg";